import SearchInput from '../../../components/base/SearchInput';

interface VideoFiltersProps {
  categories: string[];
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export default function VideoFilters({
  categories,
  selectedCategory,
  onCategoryChange,
  searchQuery,
  onSearchChange,
}: VideoFiltersProps) {
  const formatCategory = (cat: string) => {
    if (cat === 'all') return 'All Videos';
    return cat
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <div className="bg-white rounded-2xl border border-[#E8E2D6] p-6 mb-8">
      <div className="flex flex-col lg:flex-row gap-4">
        {/* Search */}
        <div className="flex-1">
          <SearchInput
            value={searchQuery}
            onChange={onSearchChange}
            placeholder="Search videos…"
            ariaLabel="Search videos"
          />
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap gap-2">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => onCategoryChange(category)}
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                selectedCategory === category
                  ? 'bg-[#1C2B1E] text-white'
                  : 'bg-[#F7F5F0] text-gray-700 hover:bg-[#E8E2D6]'
              }`}
            >
              {formatCategory(category)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
